<template><section><h2>散点图</h2>
<h3>图表介绍</h3>
<p>散点图根据数据的 x,y 确定散点的位置，气泡图是散点图的一种扩展，气泡图相较于散点图多一个维度，通过 <strong>areaField</strong> 字段可设置气泡的大小，默认为 areaField 值的大小，也可设置
<strong>areaRange</strong> 将 areaField 的值进行线性映射。气泡图还可以通过 <strong>labelField</strong> 字段来设置显示的 label 。</p>
<h3>attrs</h3>
<table>
<thead>
<tr>
<th>属性</th>
<th>说明</th>
<th>类型</th>
<th>默认值</th>
</tr>
</thead>
<tbody>
<tr>
<td>areaField</td>
<td>气泡大小字段值，不设置此值则为散点图，可通过 style 自定义</td>
<td>String</td>
<td>null</td>
</tr>
<tr>
<td>areaRange</td>
<td>面积映射，设置此值则将 areaField 进行线性映射</td>
<td>Array</td>
<td>null</td>
</tr>
<tr>
<td>labelField</td>
<td>气泡图中显示 label 的字段，可通过 style 自定义</td>
<td>String</td>
<td>null</td>
</tr>
<tr>
<td>showGuideLine</td>
<td>hover 时的辅助线,默认不显示辅助线</td>
<td>Boolean</td>
<td>false</td>
</tr>
<tr>
<td>layoutWay</td>
<td>坐标轴的相关属性</td>
<td>Object</td>
<td>null</td>
</tr>
</tbody>
</table>
<h3>可设置 style 名称</h3>
<table>
<thead>
<tr>
<th>名称</th>
<th>基本类型</th>
<th>说明</th>
</tr>
</thead>
<tbody>
<tr>
<td>point</td>
<td>面</td>
<td>点的样式,拥有Arc元素的全部属性</td>
</tr>
<tr>
<td>point:hover</td>
<td>面</td>
<td>点 hover 样式，拥有Arc元素的全部属性</td>
</tr>
<tr>
<td>label</td>
<td>文本</td>
<td>label 样式</td>
</tr>
<tr>
<td>guideline</td>
<td>线</td>
<td>指导线样式</td>
</tr>
</tbody>
</table>
</section></template><script>export default {components:{}}</script>